"use client";

import { useMemo } from "react";
import { Avatar, type AvatarProps } from "./avatar";
import { HStack } from "./layout/stack";

interface AvatarGroupProps {
	avatars: AvatarProps[];
}

const MAX_VISIBLE_AVATARS = 2;

const formatCount =
	(capacity: number) =>
	(value?: string | null): string => {
		if (!value) return "";
		if (Number(value) > capacity) {
			return `${capacity}+`;
		}

		return String(value);
	};

export function AvatarGroup({ avatars }: AvatarGroupProps): React.ReactElement {
	const count = avatars.length;
	const visible = useMemo(() => {
		return avatars.slice(0, MAX_VISIBLE_AVATARS);
	}, [avatars]);

	const hidden = count - visible.length;

	return (
		<HStack className="gap-min">
			{visible.map((a, i) => (
				<Avatar key={`${a.name}-${i}`} {...a} />
			))}
			{hidden > 0 ? (
				<Avatar
					className="bg-message-user-background text-text-body"
					formatter={formatCount(99)}
					name={String(hidden)}
				/>
			) : null}
		</HStack>
	);
}
